import type { VoidFunctionComponent } from 'react';
import PopperMenu from '../../../generic/PopperMenu';

type ActionMenuDropdownProps = {
  onSetTokenToEdit: () => void;
  onDeleteToken: () => void;
};

const ActionMenuDropdown: VoidFunctionComponent<ActionMenuDropdownProps> = ({
  onSetTokenToEdit,
  onDeleteToken,
}) => (
  <PopperMenu>
    <PopperMenu.Item
      onClick={onSetTokenToEdit}
    >
      Edit
    </PopperMenu.Item>
    <PopperMenu.Item
      onClick={onDeleteToken}
    >
      Delete
    </PopperMenu.Item>
  </PopperMenu>
);

export default ActionMenuDropdown;
